import env from 'react-dotenv';
import {StreamChat} from 'stream-chat';

export const chatClient = StreamChat.getInstance(env.API_KEY_STREAM);
